class HeroSlideshow {
  constructor(container) {
    this.container = container;
    this.slides = container.querySelectorAll('[data-hero-slide]');
    this.dots = container.querySelectorAll('.dot');
    this.prevBtn = container.querySelector('.slideshow-prev');
    this.nextBtn = container.querySelector('.slideshow-next');
    this.currentSlide = 0;
    this.autoPlayInterval = null;
    this.autoPlayDelay = 5000; // 5秒間隔

    this.init();
  }

  init() {
    console.log('HeroSlideshow initializing...', {
      slides: this.slides.length,
      dots: this.dots.length,
      prevBtn: !!this.prevBtn,
      nextBtn: !!this.nextBtn,
      container: this.container
    });
    
    // スライドの詳細情報をログ出力
    this.slides.forEach((slide, index) => {
      console.log(`Slide ${index}:`, {
        element: slide,
        hasBackground: !!slide.style.getPropertyValue('--hero-bg'),
        backgroundImage: slide.style.getPropertyValue('--hero-bg'),
        classes: slide.className
      });
    });

    if (this.slides.length <= 1) {
      console.log('Not enough slides, skipping initialization');
      return;
    }

    // 最初のスライドにis-activeクラスを付与
    this.slides.forEach((slide, index) => {
      slide.classList.remove('is-active');
      if (index === 0) {
        slide.classList.add('is-active');
      }
    });

    this.bindEvents();
    this.startAutoPlay();
    console.log('HeroSlideshow initialized successfully');
  }

  bindEvents() {
    // 前へ/次へボタン
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prevSlide());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.nextSlide());
    }

    // ドットナビゲーション
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // マウスホバーで自動再生停止
    this.container.addEventListener('mouseenter', () => this.stopAutoPlay());
    this.container.addEventListener('mouseleave', () => this.startAutoPlay());

    // キーボードナビゲーション
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prevSlide();
      if (e.key === 'ArrowRight') this.nextSlide();
    });
  }

  goToSlide(index) {
    if (index === this.currentSlide) return;

    console.log(`Going to slide ${index} from ${this.currentSlide}`);

    // 現在のスライドを非アクティブに
    this.slides[this.currentSlide].classList.remove('is-active');
    if (this.dots[this.currentSlide]) {
      this.dots[this.currentSlide].classList.remove('active');
    }

    // 新しいスライドをアクティブに
    this.currentSlide = index;
    this.slides[this.currentSlide].classList.add('is-active');
    if (this.dots[this.currentSlide]) {
      this.dots[this.currentSlide].classList.add('active');
    }

    console.log(`Slide ${index} is now active`);
  }

  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.slides.length;
    this.goToSlide(nextIndex);
  }

  prevSlide() {
    const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(prevIndex);
  }

  startAutoPlay() {
    this.stopAutoPlay();
    console.log('Starting auto play with', this.autoPlayDelay, 'ms interval');
    this.autoPlayInterval = setInterval(() => {
      console.log('Auto play: next slide');
      this.nextSlide();
    }, this.autoPlayDelay);
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
}

// ヒーロースライドショーを初期化する関数
function initHero() {
  const heroSections = document.querySelectorAll('[data-section-type="hero-slideshow"]:not([data-hero-initialized])');
  console.log('Found hero sections:', heroSections.length);
  
  heroSections.forEach((section, index) => {
    console.log(`Initializing hero section ${index + 1}:`, section);
    
    const container = section.querySelector('.slideshow-container');
    if (!container) {
      console.log('No slideshow container found in hero section');
      return;
    }
    
    // スライドとコントロールの存在を確認
    const slides = container.querySelectorAll('[data-hero-slide]');
    const dots = container.querySelectorAll('.dot');
    const prevBtn = container.querySelector('.slideshow-prev');
    const nextBtn = container.querySelector('.slideshow-next');
    
    console.log('Hero slideshow elements:', {
      slides: slides.length,
      dots: dots.length,
      prevBtn: !!prevBtn,
      nextBtn: !!nextBtn
    });
    
    if (slides.length > 0) {
      section.setAttribute('data-hero-initialized', 'true');
      new HeroSlideshow(container);
    } else {
      console.log('No slides found for hero slideshow, skipping initialization');
    }
  });
}

// 後方互換性のため残す
function initSlideshows() {
  initHero();
}

// 即座に初期化を試行（DOMが既に読み込まれている場合）
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHero);
} else {
  // DOMが既に読み込まれている場合は即座に実行
  initHero();
}

// Shopifyテーマ用の追加初期化（動的コンテンツ対応）
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', initHero);
  document.addEventListener('shopify:section:reorder', initHero);
  document.addEventListener('shopify:section:select', initHero);
  document.addEventListener('shopify:section:deselect', initHero);
}

// 追加の初期化タイミング（ページの完全読み込み後）
window.addEventListener('load', () => {
  setTimeout(initHero, 100);
});

// 定期的な初期化チェック（フォールバック）
let initCheckInterval = setInterval(() => {
  const uninitialized = document.querySelectorAll('[data-section-type="hero-slideshow"]:not([data-hero-initialized])');
  if (uninitialized.length > 0) {
    console.log('Found uninitialized hero sections, initializing...');
    initHero();
  } else {
    // すべて初期化されたらチェックを停止
    clearInterval(initCheckInterval);
  }
}, 1000);

// 10秒後にチェックを停止
setTimeout(() => {
  clearInterval(initCheckInterval);
}, 10000);
